import { CommonEnums } from 'src/app/shared/common.enums';

export class Dashboards_Inst {
    dashboards_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    conditions_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.dashboards_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.conditions_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    static parse(dashboards_InstTmp: Dashboards_Inst): Dashboards_Inst {
        let dashboards_Inst: Dashboards_Inst = new Dashboards_Inst();
        dashboards_Inst.copyFrom(dashboards_InstTmp);
        return dashboards_Inst;
    }
    getPrimaryKey(): string {
        return this.dashboards_Inst_Id + '.' + this.dxMp_Id;
    }


    copy(): Dashboards_Inst {
        let dashboards_InstTmp: Dashboards_Inst = new Dashboards_Inst();

        dashboards_InstTmp.dashboards_Inst_Id = this.dashboards_Inst_Id;
        dashboards_InstTmp.dxMp_Id = this.dxMp_Id;
        dashboards_InstTmp.nm = this.nm;
        dashboards_InstTmp.description = this.description;
        dashboards_InstTmp.ver = this.ver;
        dashboards_InstTmp.valid_Cd = this.valid_Cd;
        dashboards_InstTmp.persistFlg = this.persistFlg;
        dashboards_InstTmp.updateDt = this.updateDt;
        dashboards_InstTmp.updateBy = this.updateBy;
        dashboards_InstTmp.lastUpdateBy = this.lastUpdateBy;
        dashboards_InstTmp.conditions_Tab_Valid_Cd = this.conditions_Tab_Valid_Cd;

        return dashboards_InstTmp;
    }

    copyFrom(dashboards_InstTmp: Dashboards_Inst): void {
        this.dashboards_Inst_Id = dashboards_InstTmp.dashboards_Inst_Id;
        this.dxMp_Id = dashboards_InstTmp.dxMp_Id;
        this.nm = dashboards_InstTmp.nm;
        this.description = dashboards_InstTmp.description;
        this.ver = dashboards_InstTmp.ver;
        this.valid_Cd = dashboards_InstTmp.valid_Cd;
        this.persistFlg = dashboards_InstTmp.persistFlg;
        this.updateDt = dashboards_InstTmp.updateDt;
        this.updateBy = dashboards_InstTmp.updateBy;
        this.lastUpdateBy = dashboards_InstTmp.lastUpdateBy;
        this.conditions_Tab_Valid_Cd = dashboards_InstTmp.conditions_Tab_Valid_Cd;
    }

    compare(dashboards_InstTmp: Dashboards_Inst): string {
        let dashboards_InstString: string = this.toString(false);
        let dashboards_InstTmpString: string = dashboards_InstTmp.toString(false);

        if (dashboards_InstString != dashboards_InstTmpString) {
            return dashboards_InstString + ', ' + dashboards_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str:string= "Dashboards_Inst [dashboards_Inst_Id=" + this.dashboards_Inst_Id + ", dxMp_Id=" + this.dxMp_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy +
            ", lastUpdateBy=" + this.lastUpdateBy + ", conditions_Tab_Valid_Cd=" + this.conditions_Tab_Valid_Cd + "]";

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}

